<template>
  <ModalDialog
    ref="dialog"
    :title="`Sheet Inventory Bin List`"
    icon="fa-box"
    :showSubmit="false"
    :scrollable="true"
    @closed="onClosed">

    <Spinner v-if="loading" />
    <div v-if="!loading">
      <div class="row">
        <div class="col-12">
          <ReportFilterPopover
            class="float-right mr-2"
            headerTitle="Inventory Bin Filter"
            :showApplyButton="true"
            :showResetButton="true"
            :filterActive="hasFilterActive"
            placement="left"
            @apply="applyBinFilter"
            @reset="resetBinFilter">
            <template v-slot:popover>
              <ReportFilterGroup label="Account Location">
                <ReportMultiSelect :options="accountLocationLookup" v-model="editingBinFilter.accountLocationList" />

              </ReportFilterGroup>
            </template>
            <template v-slot:filterDisplay>
              <div v-if="appliedBinFilter.accountLocationList && appliedBinFilter.accountLocationList.length > 0">
                <i class="far fa-map-marker-alt mr-2"></i>{{appliedBinFilter.accountLocationList.length}} Location{{displayCountPlural(appliedBinFilter.accountLocationList.length)}}
              </div>
            </template>
          </ReportFilterPopover>
          <ContentTitle>Inventory Bin Breakdown</ContentTitle>
        </div>
      </div>
      <StaticDataTable class="static-table-list">
        <template v-slot:header>
          <tr>
            <th>Size (HxW) mm</th>
            <th>Bin Barcode</th>
            <th>Bin Code</th>
            <th>Bin Location</th>
            <th>Total Sheets</th>
          </tr>
        </template>
        <template v-slot:body>
          <tr v-for="invBinInfo in filteredBinLinks" :key="`${invBinInfo.id}-${invBinInfo.glassLevelId}`">
            <td>{{invBinInfo.height}} x {{invBinInfo.width}}</td>
            <td>{{invBinInfo.barcode}}</td>
            <td>{{invBinInfo.inventoryBinCode}}</td>
            <td>{{invBinInfo.accountLocationName}}</td>
            <td>{{invBinInfo.totalQuantity}}</td>
          </tr>
        </template>
        <template v-slot:empty v-if="!filteredBinLinks || filteredBinLinks.length == 0">No inventory bins found</template>
      </StaticDataTable>
    </div>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'
import ReportMultiSelect from '@/components/reporting/reportMultiSelect'
import StaticDataTable from '@/components/table/staticDataTable.vue'

export default {
  name: 'GlassInvBinListDialog',
  mixins: [
    ModalDialogMixin,
  ],
  components: {
    ModalDialog,
    ReportFilterPopover,
    ReportFilterGroup,
    ReportMultiSelect,
    StaticDataTable
  },
  props: {
    stockId: Number,
    glassSizeId: Number
  },
  data() {
    return {
      loading: false,
      glassSize: {},
      inventoryBinLinks: [],
      accountLocationLookup: [],
      defaultBinFilter: {    
        accountLocationList: []
      },
      editingBinFilter: {},
      appliedBinFilter: {},
    }
  },
  mounted() {
    this.loading = true
    this.editingBinFilter = _.clone(this.defaultBinFilter)
    this.appliedBinFilter = _.clone(this.defaultBinFilter)

    this.requestData()
  },
  computed: {
    hasFilterActive() {
      return this.appliedBinFilter.accountLocationList && this.appliedBinFilter.accountLocationList.length > 0
    },
    filteredBinLinks() {
      return this.inventoryBinLinks.filter(binLink => {
        if(this.appliedBinFilter.accountLocationList.length == 0)
          return true

        return this.appliedBinFilter.accountLocationList.includes(binLink.accountLocationId)
      })
    }
  },
  methods: {
    show() {
      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    reloadData() {
      this.requestData()
    },
    requestData() {
      Promise.all([
        this.$apiService.inventoryService.getGlassSize(this.stockId, this.glassSizeId),
        this.$apiService.adminService.getAccountLocations()
      ])
      .then(results => {
        this.glassSize = results[0].data


        this.accountLocationLookup = results[1].data.filter(location => location.isActive).map((location, index) => {
          return { name: `${location.name}`, value: location.id }
        })

        this.inventoryBinLinks = this.glassSize.inventoryBinLinks
      })
      .finally(() => {
        this.loading = false
      })
    },
    applyBinFilter() {
      this.appliedBinFilter = _.clone(this.editingBinFilter)
    },
    resetBinFilter() {
      this.editingBinFilter = _.clone(this.defaultBinFilter)
      this.appliedBinFilter = _.clone(this.defaultBinFilter)
    },
  }
}
</script>